import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getMasterDataApi} from '../api/master-data-api';
import {masterDataKeys} from '../query-keys';
import type {NextSuffixResponse} from '../types/master-data-types';

export function useNextSuffix(typeId?: string, options?: {enabled?: boolean}) {
  const tenantId = useRequiredTenantId();
  const api = getMasterDataApi();

  return useQuery<NextSuffixResponse>({
    queryKey: masterDataKeys.objectTypeNextSuffix(typeId ?? '', tenantId),
    queryFn: async () => api.getNextSuffix(typeId!),
    enabled: Boolean(typeId) && (options?.enabled ?? true),
    staleTime: 0,
  });
}
